export default "__VITE_ASSET__758c629e__"